var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0916 14.1081V15.4634C13.0916 16.9581 11.8756 18.174 10.381 18.174H3.57058C2.07592 18.174 0.859985 16.9581 0.859985 15.4634V3.53677C0.859985 2.0421 2.07592 0.826172 3.57058 0.826172H10.381C11.8756 0.826172 13.0916 2.0421 13.0916 3.53677V4.89207C13.0916 5.26636 12.7882 5.56972 12.4139 5.56972C12.0396 5.56972 11.7363 5.26636 11.7363 4.89207V3.53677C11.7363 2.7895 11.1282 2.18147 10.381 2.18147H3.57058C2.82332 2.18147 2.21528 2.7895 2.21528 3.53677V15.4634C2.21528 16.2107 2.82332 16.8187 3.57058 16.8187H10.381C11.1282 16.8187 11.7363 16.2107 11.7363 15.4634V14.1081C11.7363 13.7338 12.0396 13.4305 12.4139 13.4305C12.7882 13.4305 13.0916 13.7338 13.0916 14.1081ZM17.7116 8.33604L16.1942 6.8186C15.9295 6.5539 15.5004 6.5539 15.2358 6.8186C14.9711 7.08318 14.9711 7.51227 15.2358 7.77684L16.3152 8.85632H8.1786C7.8043 8.85632 7.50095 9.15967 7.50095 9.53397C7.50095 9.90826 7.8043 10.2116 8.1786 10.2116H16.3152L15.2358 11.2911C14.9711 11.5557 14.9711 11.9848 15.2358 12.2493C15.3682 12.3817 15.5416 12.4479 15.7149 12.4479C15.8885 12.4479 16.0618 12.3817 16.1942 12.2493L17.7116 10.7319C18.3722 10.0713 18.3722 8.99661 17.7116 8.33604Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.165217
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signoutIcon.fd693b1b.svg";
export { ForwardRef as ReactComponent };